import { focusSiblingOrTree, focusTreeAfterClear, focusFirstTreeControl } from '@Containers/TreeView/treeFocus';

/**
 * Filter lookup dialog bindings for the shared tree focus helpers
 * (`@Containers/TreeView/treeFocus`). Only the dialog's own pill selector lives
 * here — the tree selectors and the resolve-target-then-re-assert logic are
 * shared with the TreeView sidebar list so the two cannot drift.
 */

export const SELECTED_PILL_SELECTOR = '.tree-view-dialog-selected-search-items .c-els-pill__close-button';

export { focusFirstTreeControl };

/**
 * Move focus off a pill that is about to be removed, to the neighbouring pill or
 * — when it was the last one — the first tree control.
 *
 * @param {number} currentIndex DOM position of the pill being removed.
 */
export function focusAfterPillRemoval(currentIndex) {
  focusSiblingOrTree({ itemSelector: SELECTED_PILL_SELECTOR, currentIndex });
}

/** "Clear selected" removes every pill, so send focus to the tree. */
export function focusAfterClearAll() {
  focusTreeAfterClear();
}
